export const CERT_SET_CERTIFICATE = 'CERT_SET_CERTIFICATE';
export const SET_CONTRIBUTOR_CERTIFICATE = 'SET_CONTRIBUTOR_CERTIFICATE';